import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { ViewTypeByData } from '../../data-models/view-config.data-model';
import { PermissionKey } from '../../services/PermissionAndRolesKeys';
import { PermissionService } from '../../services/PermissionService';
import { viewsPFJ } from '../PortfolioOverview/state/ViewStateJ';

// Lives apart from TempMprWrapper so the navbar and the route table can read these without
// pulling the multi-period report (and echarts) into the boot bundle.
export function getShowSeparateMprRoute() {
  return (
    PermissionService.get().hasPermission(PermissionKey.canViewMultiperiod) &&
    !PermissionService.get().hasPermission(PermissionKey.canViewMetrics)
  );
}

export function useGetDefaultMprView() {
  const views = useAtomValue(viewsPFJ);
  return useMemo(() => {
    if (!views) {
      return null;
    }
    return views.find((view) => view.isDefault && view.viewType === ViewTypeByData.multiperiod);
  }, [views]);
}
